module.exports = __webpack_public_path__ + "img/audio-landscape_en.979fb7f.jpg";